import { Vue, Component } from 'vue-property-decorator'

@Component
export class BeatImageOrProducerLogo extends Vue {
    beatImageOrProducerLogo(item: IBeat | ISoundKit) {
        if (!item) return ''
        return item.image_url ? item.image_url : item.producer.image_logo_url
    }
}
